class AdBoxIndexPage
  constructor: ->
    @loadPartials()

  loadPartials: ->
    ads = $('[data-placement]')
    placements = ads.map((i, el) ->
      $(el).data 'placement'
    )
    lessonId = $(ads[0]).data 'lessonId'
    $.unique(placements).each (i, val) ->
      $.ajax {
        url: '/ads/?placement=' + val + '&lesson_id=' + lessonId
        type: 'GET'
        dataType: 'script'
      }

$ ->
  new AdBoxIndexPage
